
import { useState, useEffect, useRef } from 'react';

const benefits = [
  {
    icon: 'ri-eye-off-line',
    title: 'Görünüm',
    description: 'Neredeyse görünmez, estetik avantaj sağlar.'
  },
  {
    icon: 'ri-heart-line',
    title: 'Konfor',
    description: 'Kişiye özel, ağza tam oturur, tel-braket rahatsızlığı yoktur.'
  },
  {
    icon: 'ri-time-line',
    title: 'Tedavi Süresi',
    description: 'Planlı aşamalarla daha kısa süreçte sonuç alırsınız.'
  },
  {
    icon: 'ri-drop-line',
    title: 'Temizlik',
    description: 'Çıkar-tak sistemiyle kolay hijyen sağlanır.'
  },
  {
    icon: 'ri-restaurant-line',
    title: 'Gıda Özgürlüğü',
    description: 'Kısıtlama olmadan beslenme imkanı sunar.'
  },
  {
    icon: 'ri-search-line',
    title: 'Takip',
    description: 'Her plak ilerleme kaydeder, doktor takibi kolaydır.'
  },
  {
    icon: 'ri-user-smile-line',
    title: 'Sosyal Konfor',
    description: 'Görünmez yapısı özgüveni artırır.'
  },
  {
    icon: 'ri-settings-line',
    title: 'Kişiselleştirme',
    description: 'Her hasta için özel tedavi planı hazırlanır.'
  }
];

export default function WhyTransparentSection() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section 
      ref={sectionRef}
      id="why-transparent" 
      className="py-20 section-padding"
    >
      <div className="container-max">
        <div className={`text-center mb-16 transition-all duration-1000 ${isVisible ? 'fade-in' : 'opacity-0'}`}>
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Neden <span className="gold-text">Şeffaf Plak?</span>
          </h2>
          <div className="w-24 h-1 gold-gradient mx-auto rounded-full"></div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {benefits.map((benefit, index) => (
            <div key={index} className="premium-card text-center group">
              <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-[#D4AF37] to-[#B8941F] rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                <i className={`${benefit.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-semibold gold-text mb-3">{benefit.title}</h3>
              <p className="text-gray-300 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>
        
        <div className={`text-center mt-12 transition-all duration-1000 delay-500 ${isVisible ? 'fade-in' : 'opacity-0'}`}>
          <p className="text-sm text-gray-400 italic">
            * Tedavi planı kişiye özeldir; kesin bilgi için diş hekiminize danışın.
          </p>
        </div>
      </div>
    </section>
  );
}
